import type { ApiModels } from '@ori/global-api-client';

export function consultantSummaryToString(
  item: Nullable<ApiModels.GlobalCustomersEndConsumerDto>,
): string {
  return item ? `${item.firstName} ${item.lastName}` : '';
}
